module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    class: [
      'form-' + _vm.theme,
      'form-' + _vm.size
    ]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e21ff016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-group/form-group.vue
// module id = 38
// module chunks = 1 2 3